export default __webpack_public_path__ + "static/media/circulation.eec6150b.svg";